define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/comm",
	"csi/reflection",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"Apparel/NewStyle",
	"./NewStyleHelper",
	"./NewStylesFormController",
	"./CreateColorwaysMixin",
	"./CreateStyleOrCandidateMixin"
], function(declare, _, csi, comm, reflection, ActionControllerMixin, xml, NewStyle, NewStyleHelper, NewStylesFormController, CreateColorwaysMixin, CreateStyleOrCandidateMixin) {

	var CANDIDATE_QTY = "CandidateQuantity";
	var IS_STYLE_CANDIDATE = "IsStyleCandidate";
	var COLLECTION = "Collection";
	var PRODUCTTYPE = "ProductType";
	var TEMPLATE = "Template";
	var DESCRIPTION = "Description";
	var styleForm;
	var NUM_OF_DIGITS = 2;

	return declare([NewStyle, ActionControllerMixin, CreateColorwaysMixin, CreateStyleOrCandidateMixin], {
		// NewStyleHelper
		helper: null,

		constructor: function() {
			this.helper = new NewStyleHelper();
		},

		getFormData: function() {
			// summary: require one selection to go to second page
			var fd = this.inherited(arguments);
			fd.m_bRequireOne = true;
			return fd;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*Content*/currentPage,
							 /*Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			if (bFinish) return null;

			var fd = this.getFormData();
			var index = wizard.getIndexOfPage(nextPage);
			var dfd;
			if (index == 1) {
				// hide name field in Style form because name will come from MerchProduct
				styleForm = nextPage.getView(wizard, {
					bAddHierarchyFields: true,
					formData: fd
				});

				styleForm.defView.removeField(xml.ATTR_NAME);

				if (styleForm.defView.getField(IS_STYLE_CANDIDATE) == null) {
					this._insertCandidateFields(styleForm);
				}

				if (styleForm.defView.getField("CreateColorways") == null) {
					this._insertColorwaysField(styleForm);
				}

				dfd = this.helper.setFormDefaultValues(styleForm, fd.getSelectedValue(), this.getCache());
			}

			return this.when(dfd, function() {
				return wizard.setFormDataToPage(nextPage, fd);
			});
		},

		process: function() {
			// summary: create Styles and add to specified Collection, then create MerchProducts and add to MerchCollection, then associate MerchProducts with Styles
			var w = this.m_writer;
			var fd = this.getFormData();
			// no need to set all levels of the hierarchy - only collection
			fd.getFieldValue("ParentSeason", true);
			fd.getFieldValue("Category1", true);
			fd.getFieldValue("Category2", true);

			var rcStyle = reflection.getClass("Style");
			var raStyleNodeName = rcStyle.getAttribute(xml.ATTR_NAME);
			var styleNodeNameHasExpression = raStyleNodeName.getExpression();

			var productVersions = fd.getSelectedNodes();
			var bStyleAsCandidate = fd.getFieldValue(IS_STYLE_CANDIDATE, true);
			var styleCandidateQty = fd.getFieldValue(CANDIDATE_QTY, true);
			var collection = fd.getFieldValue(COLLECTION, true);
			var styleType = this.getFormData().getFieldValue(PRODUCTTYPE, true);
			var styleName = "";
			var styleTemplate = this.getFormData().getFieldValue(TEMPLATE, true);
			var description = this.getFormData().getFieldValue(DESCRIPTION, true);
			var bCreateColorways = this.getFormData().getFieldValue("CreateColorways", true);

			if (!bStyleAsCandidate) {
				styleCandidateQty = 1;
			}

			let urlStyles = [];
			let count = productVersions.length * styleCandidateQty;
			this._productUrls = comm.createUrls(count);
			this.m_typeNode = "Style";

			for (var i = 0; i < productVersions.length; ++i) {
				var parentCNL = productVersions[i].__Parent__;
				var styles = [];
				var styleNames = [];

				for (var j = 0; j < styleCandidateQty; ++j) {
					var url = this._productUrls[--count];
					styles.push(url);
					urlStyles.push(url);

					if (!styleNodeNameHasExpression) {
						styleName = styleCandidateQty == 1 ? "" : ('-' + `${j + 1}`.padStart(NUM_OF_DIGITS, "0"));
					}

					styleNames.push(styleName);
				}

				w.callMethod("Merchandising", "AddStyleOrCandidates")
					.addParameter(xml.PROP_URL, xml.ATTR_REF, xml.nodeGetURL(productVersions[i]))
					.addParameter("StyleURLs", xml.ATTR_REFLIST, styles)
					.addParameter("TemplateURL", xml.ATTR_REF, styleTemplate)
					.addParameter("CollectionURL", xml.ATTR_REF, collection)
					.addParameter("StyleTypeURL", xml.ATTR_REF, styleType)
					.addParameter("NameSuffix", xml.ATTR_STRINGLIST, styleNames)
					.addParameter("Description", xml.ATTR_STRING, description)
					.addParameter("ParentCNL", xml.ATTR_REF, parentCNL)
					.addParameter("StyleAsCandidate", xml.ATTR_BOOLEAN, bStyleAsCandidate)
					.addParameter("CreateColorways", xml.ATTR_BOOLEAN, bCreateColorways);

			}

			if (productVersions.length >= 1) {
				// push all style attributes
				var selectedURLs = _.map(productVersions, function(version) {
					return version.$URL;
				});

				w.callMethod("Merchandising", "PushMappingAttributesToStyleForCreate")
					.addParameter("AddURLs", xml.ATTR_REFLIST, selectedURLs)
					.addParameter("StyleURLs", xml.ATTR_REFLIST, urlStyles);
			}

			this.helper._applyFormFieldsOnStyles(this, urlStyles, styleCandidateQty);

			// reset to null so the last new Style is not added to second request to get new data
			this.m_urlNode = null;
			this.publish();
		},

		postProcessSuccess: function() {
			// summary: refresh selected rows
			var obj = csi.hashArray(this.getFormData().getSelectedValue(), null, Boolean);
			var view = this.widget;

			return view.refreshDataRows(function(tr) {
				return obj[view.getRefNodeUrl(tr)];
			});
		},

		toWriter: function() {
			// FIXME: This method will never get called, because we have overridden the method "process" which won't
			// call this.inherited (NewController.js calls this.toWriter).
			var fd = this.getFormData();
			fd.getFieldValue(IS_STYLE_CANDIDATE, true);
			fd.getFieldValue(CANDIDATE_QTY, true);

			this.inherited(arguments);
		},

		onWizardViewPreCreate: function(/*csi.wizard.Widget*/wizard, /*Content*/page, /*View*/defView, /*Object*/viewParams) {
			if (wizard.getIndexOfPage(page) == 1) {
				defView.classController = NewStylesFormController;
			}
		}
	});
});